module.exports = __webpack_public_path__ + "static/media/social5.9cc0b6de.png";